import DetailTitle from "@/components/DetailTitle";
import styles from "./index.module.scss";
import intl from "react-intl-universal";
const OgaWebsite = () => {
	return <div className={styles.ogaWebsiteBox}>
		<DetailTitle title="OGE Alliance Website" />
		<h3>{intl.get("community.For community news and updates")}</h3>
		<ul>
			<li><a href="/blog-news/blog">{intl.get("Header.Blog")}</a> - {intl.get("community.blog posts")}</li>
			<li><a href="/blog-news/events">{intl.get("Header.Events")}</a> – {intl.get("community.Information about upcoming conferences, webinars, and community meetups")}</li>
			<li><a href="/blog-news/news">{intl.get("Header.News")}</a>– {intl.get("community.Announcements, press releases, and highlights from the OGE Alliance community")}</li>
		</ul>
	</div>
}
export default OgaWebsite;